// assets
import {IconBuildingEstate, IconNews, IconCategory, IconUserCheck, IconPeace, IconAddressBook, IconUsers, IconUserPlus, IconHelp, IconSitemap } from '@tabler/icons';


// constant
const icons = {
    IconBrandChrome: IconUsers,
    IconAddUser: IconUserPlus,
    IconCohort: IconAddressBook,
    IconChapter: IconPeace,
    IconPermission: IconUserCheck,
    IconCategory: IconCategory,
    IconNews: IconNews,
    IconHelp: IconHelp,
    IconBuildingEstate: IconBuildingEstate,
    IconSitemap: IconSitemap
};

//-----------------------|| SAMPLE PAGE & DOCUMENTATION MENU ITEMS ||-----------------------//



export const others = {
    id: 'sample-docs-roadmap',
    title: 'Composants',
    type: 'group',
    children: [
        {
            id: 'user',
            type: 'collapse',
            icon: icons['IconBrandChrome'],
            title: 'Utilisateurs',
            type: 'item',
            url: '/utilisateurs',
            breadcrumbs: false

        },
        {
            id: 'permissions',
            type: 'collapse',
            icon: icons['IconPermission'],

            title: 'Role',
            type: 'item',
            url: '/roles',
            breadcrumbs: false
        },
        {
            id: 'path',
            type: 'collapse',
            icon: icons['IconCohort'],
            title: 'Paths',
            type: 'item',
            url: '/paths',
            breadcrumbs: false

        },
        // {
        //     id: 'lesson',
        //     type: 'collapse',
        //     icon: icons['IconChapter'],
        //     title: 'Leçons',
        //     type: 'item',
        //     url: '/chapitres',
        //     breadcrumbs: false
        // },
        {
            id: 'category',
            type: 'collapse',
            icon: icons['IconCategory'],
            title: 'Categoies',
            type: 'item',
            url: '/categories',
            breadcrumbs: false

        },
        {
            id: 'establishment',
            type: 'collapse',
            icon: icons['IconBuildingEstate'],
            title: 'Etablissement',
            type: 'item',
            url: '/etablissements',
            breadcrumbs: false

        },

    ]

};
